import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import logo from "../assets/images/tiger2.png";
import shap from "../assets/images/shape1.png";
import "../assets/css/Login.css";
import { Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import config from "../config";
import axios from "axios";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
const Forgot = () => {
    const [email, setEmail] = useState("");
    const [cooldown, setCooldown] = useState(0);
    useEffect(() => {
        if (cooldown <= 0) return;

        const timer = setInterval(() => {
            setCooldown(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [cooldown]);



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.warning("Please enter your email");
            return;
        }

        toast.info("You can request another reset link in 60 seconds.");

        try {
            const response = await axios.post(
                `${config.API_BASE_URL}/cforgotpass/forgot-password`,
                { email }
            );
            setCooldown(60);
            toast.success(response.data);

        } catch (error) {
            toast.error(
                error.response?.data?.message ||
                "Error sending reset link. Please try again."
            );
        }
    };
    return (
        <>
            <Helmet>
                <title>Forgot Password | Shaadi Material</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <section className="useraccountDiv">
                <div class="fxt-shape">
                    <div class="fxt-transformX-L-50 fxt-transition-delay-1">
                        <img src={shap} alt="shap" />
                    </div>
                </div>
                <Container>
                    <Row className="mx-0 breadcrumb_part align-items-center">
                        <Col lg={8}>
                            <div className="fxt-column-wrap justify-content-center">
                                <div>
                                    <div className="fxt-transformX-L-50 fxt-transition-delay-3">
                                        <Link to="/" className="logo me-5">
                                            <img src={logo} alt="Logo" style={{ height: '150px' }} />
                                        </Link>
                                    </div>
                                    <div className="fxt-transformX-L-50 fxt-transition-delay-5">
                                        <div className="fxt-middle-content">
                                            <h1 className="fxt-main-title">Recover Password<br /> Shaadi Material</h1>
                                            <div className="fxt-switcher-description1">If you have an account You can
                                                <Link to="/login" className="fxt-switcher-text ms-2 fw-bold text-info">Sign In</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="prof_content user-dash">
                                <div className="d-flex flex-column gap-2 mb-2">
                                    <label >Email</label>
                                    <InputText
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="name@example.com"
                                    />
                                </div>

                                <Button
                                    label={cooldown > 0 ? `Wait ${cooldown} seconds` : 'Send Reset Link'}
                                    className="py-2 w-100 custbuttonpink"
                                    style={{ height: "50px" }}
                                    disabled={cooldown > 0}
                                    onClick={handleSubmit}
                                />
                                <p className="text-secondary mt-4">Return to? <Link to="/login" className="text-info">Log in</Link></p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Forgot;